"use strict";
exports.__esModule = true;
exports.checkPassword = void 0;
var opaque_types_1 = require("@shef/opaque-types");
var Either_1 = require("fp-ts/Either");
var checkPassword = function (password) {
    var MIN_PASSWORD_LENGTH = 6;
    var MAX_PASSWORD_LENGTH = 64;
    var length = (password === null || password === void 0 ? void 0 : password.length) || 0;
    if (length === 0) {
        return (0, Either_1.left)("Please enter a password");
    }
    if (length < MIN_PASSWORD_LENGTH || length > MAX_PASSWORD_LENGTH) {
        return (0, Either_1.left)("Password must be " + MIN_PASSWORD_LENGTH + " to " + MAX_PASSWORD_LENGTH + " characters long");
    }
    return (0, Either_1.right)((0, opaque_types_1.makeOpaque)(password));
};
exports.checkPassword = checkPassword;
//# sourceMappingURL=checkPassword.js.map